

export default function links() {

  return (editor, root) => {
    let anchor;

    function onClick(event) {
      if (event.target.matches && event.target.matches('a[href]')) {
        event.preventDefault();
        if (dabbleLink(event.target)) {
          location.pathname = event.target.pathname;
        } else {
          window.open(event.target.href, event.target.target);
        }
      }
    }

    // Rewrite any full-path links within Dabble to their hash-only version
    function onChanging({ change, source, selection }) {
      let modified = false;

      change.ops.forEach(op => {
        if (op.attributes && op.attributes.link && op.attributes.link[0] !== '#') {
          if (!anchor) anchor = root.ownerDocument.createElement('a');
          anchor.href = op.attributes.link;
          if (dabbleLink(anchor) && op.attributes.link.startsWith('http')) {
            op.attributes.link = anchor.pathname;
            modified = true;
          }
        }
      });

      if (modified) {
        editor.updateContents(change, source, selection);
        return false;
      }
    }

    root.addEventListener('click', onClick);
    editor.on('text-changing', onChanging);

    return {
      onDestroy() {
        root.removeEventListener('click', onClick);
        editor.off('text-changing', onChanging);
      }
    }
  };
}

function dabbleLink(anchor) {
  return anchor.host === window.location.host && anchor.pathname === window.location.pathname;
}
